import { EventAggregator } from 'aurelia-event-aggregator';
import { bindable, computedFrom, autoinject } from 'aurelia-framework';
import { DOM } from 'aurelia-pal';
import { Router } from 'aurelia-router';
import { State } from '../../../services/global-state';
import { Account } from '../../../models/customer';

@autoinject()
export class InstallmentsSelectOption {
	installments: any;
	maxDiscount: any;
	accounts: Array<Account>;
	amount: number;
	portfolioSettings: any;

	constructor(private router: Router, private state: State, private eventAggregator: EventAggregator) {
		this.maxDiscount = 0;
	}

	activate(params, routeData) {
		this.accounts = routeData.accounts;
		if (params.id && this.getAccountAndPortfolio(params.id)) {
			this.getInstallmentOptions();
			this.findMaxDiscount();
			this.sortInstallments();
		} else {
			this.goBack();
		}
	}

	getAccountAndPortfolio(accountId: string): boolean {
		let success = true;

		if (!this.state.accounts.find(acct => acct.id === accountId)) {
			success = false;
		} else {
			this.amount = this.accounts.reduce((sum, account) => {
				return sum + account.balance
			}, 0);
			this.portfolioSettings = this.state.business.fetchPortfolioSettings(this.accounts[0].portfolioName);
			if (!this.portfolioSettings) {
				success = false;
			}
		}
		return success;
	}

	getInstallmentOptions() {
		this.installments = [];
		this.portfolioSettings.settings.paymentTypes.installments.balanceRanges.forEach((range, index, list) => {
			// Find range within account balance then get installments from range
			if (this.amount >= range.min && this.amount <= range.max) {
				this.installments = range.installments;
				this.computePlanGrid();
			}
		});
	}

	sortInstallments() {
		this.installments = this.installments.sort((a, b) => a.number - b.number);
	}

	isEvenPayments(installment) {
		if (parseFloat(installment.firstPayment) - parseFloat(installment.paymentAfterFirst) === 0) {
			return true;
		}
		return false;
	}

	findMaxDiscount() {
		let referenceDiscount: any = 0;
		this.installments.forEach((installment) => {
			let discount = installment.discountPercent;
			if (parseFloat(discount) > parseFloat(referenceDiscount)) {
				referenceDiscount = discount;
				this.maxDiscount = discount;
			}
		});
	}

	computePlanGrid() {
		this.installments.forEach(installment => {

			var discount = this.amount * (installment.discountPercent / 100);

			installment.accountBalance = this.amount;
			installment.totalAmount = (this.amount - discount).toFixed(2);

			var integerTotal = Math.round(installment.totalAmount * 100);
			var integerReminder = integerTotal % installment.number;
			var integerAverage = Math.floor(integerTotal / installment.number);
			var integerFirst = integerAverage + integerReminder;

			installment.firstPayment = integerFirst / 100;
			installment.paymentAfterFirst = integerAverage / 100;
		});
	}
	@computedFrom('maxDiscount')
	get areDiscountsAvailable() {
		return (parseFloat(this.maxDiscount) > 0 ? true : false);
	}

	installmentOptionSelected(selectedOption) {
		selectedOption.discountPercent = selectedOption.discountPercent === '' ? 0 : selectedOption.discountPercent;
		const setupPlanRoute = this.router.routes.find(x => x.name === 'installments/setup-payment-plan');
		setupPlanRoute.installment = selectedOption;
		setupPlanRoute.overrides = null;
		setupPlanRoute.negotiatorActivitySessionId = null;
		setupPlanRoute.accounts = this.accounts;
		this.router.navigateToRoute(setupPlanRoute.name, { id: this.accounts[0].id });
	}

	goBack() {
		this.router.navigateBack();
	}

}
